<template>
  <div class="metal_changed_pic">
    <img :src="imageUrl" />
    <div class="metal-text">
      <div class="commemorativeMedalGreetingsAndName">
        <div class="textContainer">
          <span class="text" v-html="textInfo[0].textContent"></span>
        </div>
      </div>
      <div class="commemorativeMedalGreetingMessage">
        <div class="textContainer">
          <span class="text" v-html="textInfo[1].textContent"></span>
        </div>
      </div>
      <div class="commemorativeMedalSenderName">
        <div class="textContainer">
          <span class="text" v-html="textInfo[2].textContent"></span>
        </div>
      </div>
      <div class="commemorativeMedalGreetingImage">
        <img
          v-if="
            !['nothing', 'custom'].includes(
              $store.getters.currentCustom.engraving_content.content
                .commemorativeMedalGreetingImageOption
            )
          "
          :src="commemorativeMedalGreetingImageUrl"
          alt="祝賀圖片"
        />
      </div>
    </div>
  </div>
</template>

<script>
import commonMixin from "@/commonMixin.js";
import { commemorativeMedalGreetingImageOptions } from "@/constData/engravingData.js";
export default {
  name: "CustomizeMetalAX",
  mixins: [commonMixin],
  mounted() {
    this.calcEmFontsizeBase();
    this.controlWrapNotReverse(
      0,
      this.customTextCommemorativeMedalGreetingsAndName
    );
    this.controlFontsize(0, this.customTextCommemorativeMedalGreetingsAndName);
    this.controlWrapNotReverse(
      1,
      this.customTextCommemorativeMedalGreetingMessage
    );
    this.controlFontsize(1, this.customTextCommemorativeMedalGreetingMessage);
    this.controlWrapNotReverse(2, this.customTextCommemorativeMedalSenderName);
    this.controlFontsize(2, this.customTextCommemorativeMedalSenderName);
  },
  data() {
    return {
      commemorativeMedalGreetingImageOptions:
        commemorativeMedalGreetingImageOptions,
      textInfo: [
        {
          name: "commemorativeMedalGreetingsAndName",
          lineLimit:
            this.$store.getters.textSettingByComponentCode("AX")
              .commemorativeMedalGreetingsAndName.lineLimit,
          textLimit:
            this.$store.getters.textSettingByComponentCode("AX")
              .commemorativeMedalGreetingsAndName.textLimit,
          maxFontsize:
            this.$store.getters.textSettingByComponentCode("AX")
              .commemorativeMedalGreetingsAndName.maxFontsize,
          emFontsize: "",
          changeFontsizeLimit: "",
          textContent: "",
        },
        {
          name: "commemorativeMedalGreetingMessage",
          lineLimit:
            this.$store.getters.textSettingByComponentCode("AX")
              .commemorativeMedalGreetingMessage.lineLimit,
          textLimit:
            this.$store.getters.textSettingByComponentCode("AX")
              .commemorativeMedalGreetingMessage.textLimit,
          maxFontsize:
            this.$store.getters.textSettingByComponentCode("AX")
              .commemorativeMedalGreetingMessage.maxFontsize,
          emFontsize: "",
          changeFontsizeLimit: "",
          textContent: "",
        },
        {
          name: "commemorativeMedalSenderName",
          lineLimit:
            this.$store.getters.textSettingByComponentCode("AX")
              .commemorativeMedalSenderName.lineLimit,
          textLimit:
            this.$store.getters.textSettingByComponentCode("AX")
              .commemorativeMedalSenderName.textLimit,
          maxFontsize:
            this.$store.getters.textSettingByComponentCode("AX")
              .commemorativeMedalSenderName.maxFontsize,
          emFontsize: "",
          changeFontsizeLimit: "",
          textContent: "",
        },
      ],
    };
  },
  watch: {
    customTextCommemorativeMedalGreetingsAndName() {
      this.controlWrapNotReverse(
        0,
        this.customTextCommemorativeMedalGreetingsAndName
      );
      this.controlFontsize(
        0,
        this.customTextCommemorativeMedalGreetingsAndName
      );
    },
    customTextCommemorativeMedalGreetingMessage() {
      this.controlWrapNotReverse(
        1,
        this.customTextCommemorativeMedalGreetingMessage
      );
      this.controlFontsize(1, this.customTextCommemorativeMedalGreetingMessage);
    },
    customTextCommemorativeMedalSenderName() {
      this.controlWrapNotReverse(
        2,
        this.customTextCommemorativeMedalSenderName
      );
      this.controlFontsize(2, this.customTextCommemorativeMedalSenderName);
    },
  },
  computed: {
    imageUrl() {
      const metalData =
        this.$store.getters.customizeMetalDataByComponentCode("AX");
      return metalData.imagePath;
    },
    commemorativeMedalGreetingImageUrl() {
      const commemorativeMedalGreetingImageOption =
        this.$store.getters.currentCustom.engraving_content.content
          .commemorativeMedalGreetingImageOption;

      return commemorativeMedalGreetingImageOptions.filter(
        (option) => option.value === commemorativeMedalGreetingImageOption
      )[0].image;
    },
    customTextCommemorativeMedalGreetingsAndName() {
      return this.$store.getters.currentCustom.engraving_content.content
        .commemorativeMedalGreetingsAndName;
    },
    customTextCommemorativeMedalGreetingMessage() {
      return this.$store.getters.currentCustom.engraving_content.content
        .commemorativeMedalGreetingMessage;
    },
    customTextCommemorativeMedalSenderName() {
      return this.$store.getters.currentCustom.engraving_content.content
        .commemorativeMedalSenderName;
    },
  },
};
</script>

<style scoped lang="scss">
.metal_changed_pic {
  position: relative;
  font-family: "Noto Serif TC";
  img {
    width: 100%;
  }
  .metal-text {
    position: absolute;
    top: 63px;
    left: 38px;
    color: $primaryLightColor;
    font-weight: 800;
    @include betweenTableTablePro {
      transform: scale(0.8);
      top: 25px;
      left: -13px;
    }
    @include table {
      transform: scale(0.7);
      top: 5px;
      left: -40px;
    }
    @include phone {
      transform: scale(0.64);
      top: -9px;
      left: -54px;
    }
  }
}
.commemorativeMedalGreetingsAndName {
  height: 85px;
  width: 426px;
  border: 1px dashed $primaryLightColor;
  margin: 0 auto;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  .textContainer {
    width: 426px;
    span {
      white-space: nowrap;
    }
  }
}
.commemorativeMedalGreetingMessage {
  width: 309px;
  height: 110px;
  margin: 10px 0;
  border: 1px dashed $primaryLightColor;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  .textContainer {
    width: 309px;
    span {
      white-space: nowrap;
    }
  }
}
.commemorativeMedalSenderName {
  width: 309px;
  height: 45px;
  border: 1px dashed $primaryLightColor;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  .textContainer {
    width: 309px;
    span {
      white-space: nowrap;
    }
  }
}
.commemorativeMedalGreetingImage {
  // 相對位置是與 metal-text 相比
  position: absolute;
  top: 95px;
  left: 318px;
  width: 108px;
  height: 108px;
  border: 1px dashed $primaryLightColor;
  img {
    width: 100%;
  }
}
</style>
